import { useEffect, useState } from 'react';
import { fetchOwners } from 'purchase-motions-api/query/monetization';
import Raven from 'raven-js';
import { isRpcError } from '../utils/error';
import { MARKETING_SALES, IGS_NURTURING } from '../types/RepInfo';
import { hasAssignableOverride } from '../utils/talkToSales';
const OVERRIDE_ASSIGNABLE_REP_INFO = {
  link: 'https://meetings.hubspotqa.com/dfeehrer',
  name: 'Rev N. Yu',
  type: IGS_NURTURING
};
export const useRepInfo = () => {
  const [repInfo, setRepInfo] = useState();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  useEffect(() => {
    if (hasAssignableOverride()) {
      setRepInfo(OVERRIDE_ASSIGNABLE_REP_INFO);
      setLoading(false);
    } else {
      fetchOwners().then(ownerInfo => {
        var _ownerInfo$MARKETING_, _ownerInfo$IGS_NURTUR;
        if (ownerInfo !== null && ownerInfo !== void 0 && (_ownerInfo$MARKETING_ = ownerInfo.MARKETING_SALES) !== null && _ownerInfo$MARKETING_ !== void 0 && _ownerInfo$MARKETING_.link) {
          setRepInfo(Object.assign({}, ownerInfo.MARKETING_SALES, {
            type: MARKETING_SALES
          }));
        } else if (ownerInfo !== null && ownerInfo !== void 0 && (_ownerInfo$IGS_NURTUR = ownerInfo.IGS_NURTURING) !== null && _ownerInfo$IGS_NURTUR !== void 0 && _ownerInfo$IGS_NURTUR.link) {
          setRepInfo(Object.assign({}, ownerInfo.IGS_NURTURING, {
            type: IGS_NURTURING
          }));
        }
      }).catch(e => {
        if (!isRpcError(e) || e.cause.status !== 0) {
          Raven.captureException(new Error('Failed at fetchOwners', {
            cause: e
          }));
          setError(e);
        }
      }).finally(() => setLoading(false));
    }
  }, []);
  return {
    loading,
    error,
    repInfo
  };
};